<template>
  <v-container fluid>
    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :loading="fetching"
          :headers="headers"
          :items="items"
          :sort-by="['store']"
          must-sort
          sort-desc
          class="elevation-1"
        >
          <template v-slot:item.stockMinimum="{ item }">
            <v-chip
              :color="getColor(item)"
              dark
            >{{ item.stockMinimum || 0 }}</v-chip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { format } from "date-fns";
// import generateId from "@/idGenerator";
import { getApi } from "@/api";

export default {
  data() {
    return {
      tab: null,
      fetching: true,
      items: []
    };
  },
  computed: {
    headers() {
      let boxTypes = Object.values(this.$store.state.entities.boxTypes).sort((a, b) => {
        a = a.order ? a.order : 0;
        b = b.order ? b.order : 0;
        return b - a;
      });
      
      return [
        {
          text: "מיקום",
          value: "store"
        },
        {
          text: "סה״כ",
          value: "total"
        },
        {
          text: "תקן מלאי",
          value: "stockMinimum"
        }
      ].concat(
        boxTypes.map(item => {
          return {
            text: item.title,
            value: item._id
          };
        })
      );
    },
    stockBoxType() {
      return Object.values(this.$store.state.entities.boxTypes).find(item => item.key === 'STOCK');
    },
  },
  methods: {
    format,
    fetch() {
      getApi()
        .then(api => {
          this.fetching = true;
          return api.get("/reports/stock");
        })
        .then(({ data }) => {
          let keys = Object.keys(data);
          for (let key of keys) {
            this.items.push(
              Object.assign(
                {
                  store: this.storeById(key),
                  total: Object.values(data[key]).reduce((p, c) => p + c, 0),
                  stockMinimum: this.stockMinimumByStoreId(key)
                },
                data[key]
              )
            );
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    storeById(id) {
      if (id) {
        let store = this.$store.state.entities.stores[id];
        if (store) {
          return store.title;
        }
      }
    },
    stockMinimumByStoreId(id) {
      if (id) {
        let store = this.$store.state.entities.stores[id];
        if (store) {
          return store.stockMinimum;
        }
      }
    },
    getColor(item) {
      let stockId = this.stockBoxType ? this.stockBoxType._id : null;
      if ((item.stockMinimum || 0) < item[stockId]) {
        return 'green';
      } else if ((item.stockMinimum || 0) == item[stockId]) {
        return 'orange';
        } else {
        return 'red';
      }
    }
  },
  mounted() {
    this.fetch();
  },
  watch: {},
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
